import { Container, Box, Typography, Grid, Button } from "@mui/material";
import HomeLayout from "/layouts/HomeLayout";
import { useState } from "react";
import { validateEmail } from "utils/functions";
import { createFeedback } from "context/actions/feedback";

// components
import CustomTextBox from "components/CustomTextBox";
import CustomSnackBar from "components/CustomSnackBar";
import CustomComboBox from "components/CustomComboBox";

const Content = ({}) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [description, setTypes] = useState("");
  const [name, setName] = useState("");

  const [refresh, setRefresh] = useState(false);
  const [snack, setSnack] = useState({
    isOpen: false,
    msg: "",
    type: "success",
  });

  const [errors, setErrors] = useState({
    firstName: false,
    lastName: false,
    email: false,
    phone: false,
    description: false,
    name: false,
  });

  const onChangeFirstName = (value) => setFirstName(value);
  const onChangeLastName = (value) => setLastName(value);
  const onChangeEmail = (value) => setEmail(value);
  const onChangePhone = (value) => setPhone(value);
  const onChangeTypes = (value) => setTypes(value);
  const onChangeName = (value) => setName(value);

  const validateForm = () => {
    const newErrors = {
      firstName: firstName === "",
      lastName: lastName === "",
      email: email === "" || !validateEmail(email),
      phone: phone === "",
      description: description === "",
      name: name === "",
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error);
  };

  const handleSave = async () => {
    if (!validateForm()) {
      setSnack({
        isOpen: true,
        msg: "Please fill all the fields correctly.",
        type: "error",
      });
      return;
    }

    const data = { firstName, lastName, email, phone, description, name };
    const res = await createFeedback(data);

    if (res?.status === "success") {
      setRefresh(!refresh);
      setSnack({
        isOpen: true,
        msg: "Sent successfully",
        type: "success",
      });
      // reset form
      setFirstName("");
      setLastName("");
      setEmail("");
      setPhone("");
      setTypes("");
      setName("");
    } else {
      setSnack({
        isOpen: true,
        msg: "Алдаа гарлаа",
        type: "error",
      });
    }
  };

  const handleCloseSnack = () => {
    setSnack({ ...snack, isOpen: false });
  };

  const items = [
    { name: "Гадаад аялал", value: "Гадаад аялал" },
    { name: "Дотоод аялал", value: "Дотоод аялал" },
  ];

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        backgroundImage: "url('/add.png')", // энд өөрийн зурагны замыг оруул
        backgroundSize: "cover",
        backgroundPosition: "top",
        minHeight: "100vh", // бүх өндөр эзлэх
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop:10,
        paddingBottom:20
        
      }}
    >
      <Container maxWidth="sm" disableGutters className="my-[100px]">
        <Box
          className="bg-white h-full p-6 md:p-8 rounded-2xl"
          sx={{
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            opacity: 0.95,
          }}
        >
          <Typography variant="h5" style={{
                fontFamily: "Philosopher",
                color: "#4f4235",
                fontStyle: "bold",
                fontSize:30
              }}>
            Аялалд бүртгүүлэх
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Та аяллын мэдээллээ үнэн зөв бөглөнө үү.
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomComboBox
                label="Аяллын төрөл"
                items={items}
                value={description}
                onChange={onChangeTypes}
                error={errors.description}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomTextBox
                label="Аяллын нэр"
                value={name}
                error={errors.name}
                onChange={onChangeName}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextBox
                label="Овог"
                value={firstName}
                error={errors.firstName}
                onChange={onChangeFirstName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTextBox
                label="Нэр"
                value={lastName}
                error={errors.lastName}
                onChange={onChangeLastName}
              />
            </Grid>

            <Grid item xs={12}>
              <CustomTextBox
                label="Email"
                value={email}
                error={errors.email}
                onChange={onChangeEmail}
              />
            </Grid>

            <Grid item xs={12}>
              <CustomTextBox
                label="Утас"
                value={phone}
                error={errors.phone}
                onChange={onChangePhone}
              />
            </Grid>
          </Grid>

          <Box className="mt-6 text-right">
            <Button
              variant="contained"
              className="bg-[#545454] hover:bg-[#333]"
              onClick={handleSave}
              sx={{
                borderRadius: "10px",
                px: 4,
                py: 1.2,
                fontWeight: 600,
                textTransform: "none",
              }}
            >
              Илгээх
            </Button>
          </Box>
        </Box>
      </Container>

      <CustomSnackBar
        open={snack.isOpen}
        msg={snack.msg}
        handleClose={handleCloseSnack}
        type={snack.type}
      />
    </Container>
  );
};

Content.Layout = HomeLayout;

export default Content;
